type PostHogOrganizationClient = {
  setPersonPropertiesForFlags: (properties: Record<string, unknown>) => void
  group: (
    groupType: string,
    groupKey: string,
    properties?: Record<string, unknown>
  ) => void
}

type OrganizationContext = {
  email: string
  organizationId?: number | string | null
  organizationName?: string | null
}

export function setPostHogOrganizationContext(
  client: PostHogOrganizationClient,
  { email, organizationId, organizationName }: OrganizationContext
) {
  client.setPersonPropertiesForFlags({
    email,
    organization_id: organizationId ?? null,
    organization_name: organizationName ?? null
  })

  if (organizationId != null) {
    client.group('organization', String(organizationId), {
      name: organizationName ?? undefined
    })
  }
}
